export default {
  title: 'システムログ',
  source: '接続先インスタンス: {{instanceId}} · ファイル: {{fileName}}',
  instances: 'インスタンス',
  localInstance: '{{instanceId}}（接続中）',
  instanceLost: 'このインスタンスはログの送信を停止しました（シャットダウンまたは到達不能）',
  status: {
    connecting: '接続中...',
    connected: 'ライブ',
    disconnected: '切断',
  },
  searchPlaceholder: '行を絞り込み...',
  levels: {
    error: 'エラー',
    warn: '警告',
    info: '情報',
    debug: 'デバッグ',
  },
  httpRequests: 'HTTPリクエスト',
  httpRequestsTitle: 'サーバーが処理したHTTPリクエストのログ行を表示または非表示にします',
  maxLines: '最大行数',
  pause: '一時停止',
  resume: '再開（新規 {{count}} 件）',
  export: 'エクスポート',
  exportTitle: '読み込まれたすべての行（フィルター適用なし）をテキストファイルにダウンロードします',
  clear: 'クリア',
  reconnect: '再接続',
  jumpToLatest: '最新へ移動',
  fileNotFound: 'インスタンス {{instanceId}}: ログファイル {{fileName}} が見つかりません。作成を待機しています',
  linesCount: '{{total}} 行中 {{visible}} 行を表示',
  markers: {
    rotated: 'ログファイルがローテーションされました',
    skipped: '書き込まれた行が多すぎます: 一部の行をスキップしました',
    truncated: '古い行は読み込まれていません',
  },
}
